import React from 'react'
import { ErrorContent } from '../../components/ErrorContent/ErrorContent'
import { Title } from '../../components/Title/Title'
import { useRouter } from '../../hooks/useRouter'

interface IProps {
  code?: number
}

export const ErrorPage = ({ code = 500 }: IProps): React.ReactElement => {
  const { query } = useRouter()
  const message: string | undefined =
    typeof query.message === 'string'
      ? query.message
      : query.message && Array.isArray(query.message)
      ? query.message[0]
      : ''
  const title = code === 404 ? 'Not Found' : 'Error'

  return (
    <>
      <Title value={title} />
      <ErrorContent
        error={{ code, message, timestamp: new Date().toJSON() }}
        className="my-5"
        style={{ paddingTop: '4rem' }}
        description={message}
      />
    </>
  )
}
